import { render, staticRenderFns } from "./chunkStudentResultForm.vue?vue&type=template&id=7569d7d8&scoped=true&"
import script from "./chunkStudentResultForm.vue?vue&type=script&lang=js&"
export * from "./chunkStudentResultForm.vue?vue&type=script&lang=js&"
import style0 from "./chunkStudentResultForm.vue?vue&type=style&index=0&id=7569d7d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7569d7d8",
  null
  
)

export default component.exports